import axios from '../../helpers/axios-setup';

export const uploadFileTemplates = (data: FormData) => axios.post('/interoperability-templates/upload', data);
